import type {
  MurajaahNextReviewRecommendation,
  MurajaahQueueTier,
  MurajaahSessionStatus,
  MurajaahSessionType,
} from '@/features/murajaah/types';

export const SESSION_TYPE_LABELS: Readonly<Record<MurajaahSessionType, string>> = {
  SCHEDULED: 'Terjadwal',
  SPONTANEOUS: 'Spontan',
};

export const SESSION_STATUS_LABELS: Readonly<Record<MurajaahSessionStatus, string>> = {
  SCHEDULED: 'Terjadwal',
  COMPLETED: 'Selesai',
  CANCELLED: 'Dibatalkan',
};

/** Display-only label for the derived MISSED state (never a persisted status - see types.ts). */
export const SESSION_MISSED_LABEL = 'Terlewat';

export const NEXT_REVIEW_RECOMMENDATION_LABELS: Readonly<
  Record<MurajaahNextReviewRecommendation, string>
> = {
  REVIEW_AGAIN_SOON: 'Ulangi Segera',
  REVIEW_ON_SCHEDULE: 'Sesuai Jadwal',
  GRADUATE_TO_MAINTENANCE: 'Lulus ke Pemeliharaan',
};

/** ADR-022 Addendum's own tier names, verbatim. */
export const QUEUE_TIER_LABELS: Readonly<Record<MurajaahQueueTier, string>> = {
  1: 'Baru Dihafal',
  2: 'Perlu Perhatian',
  3: 'Terlewat',
  4: 'Giliran Rutin',
};

/** Shared between the Queue page and the Dashboard's Queue summary card. */
export function queueTierBadgeVariant(
  tier: MurajaahQueueTier,
): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (tier === 1) {
    return 'default';
  }
  if (tier === 2 || tier === 3) {
    return 'destructive';
  }
  return 'outline';
}
